import { users } from './users';
import { blogs } from './blogs';
export default {
  users,
  blogs
};



// WEBPACK FOOTER //
// ./src/data/tmp/index.js